import {Component} from "@angular/core";
import {DOCUMENT_TYPES, ITEM_ID_TYPE, VALUE_TYPE} from "../../enums/enums";
import {BusService} from "../../services/bus.service";
import {paramsHelper} from "../../helpers/params-helper";
import {UI_TEXTS} from "../../enums/e-texts";


@Component({
  templateUrl: "./drop.attributes-page.component.html"
})


export class DropAttributesPageComponent {
  UI_TEXTS = UI_TEXTS;
  VALUE_TYPE = VALUE_TYPE;
  ITEM_ID_TYPE = ITEM_ID_TYPE;

  collectionParams = paramsHelper.collection()
    .setObjectType(DOCUMENT_TYPES.DROP)
    .setListLabels("", "%/name%")
    .setSearchParams(paramsHelper.search()
      .addNumberParam("id"));

  pageParams = paramsHelper.page()
    .setDisabledOptionVisible(false)
    .setTitle("Аттрибуты - Дроп");


  document: any;


  constructor(private busService: BusService) {
    this.busService.onDocumentUpdated
      .subscribe(
        e => this.document = e.document);
  }


  onAddElementClick(): void {
    let element: any = {
      oneItem: false,
      resourceId: -1,
      count: 1,
      chance: 0
    };

    let elements: any[] = this.document.elements;
    elements.push(element);
  }


  onElementRemoved(removedItem: any) {
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/attributes/drop.attributes-page.component.ts